<script>
	import {onMount, beforeUpdate, afterUpdate} from 'svelte'
	import {send, close, server, connected} from '@sock/connection'
	import log, {messages} from '@sock/log'

	let autoscroll = true
	let console

	const down = () => console.scrollTo(0, console.scrollHeight)

	beforeUpdate(() =>
		autoscroll = console && (console.offsetHeight + console.scrollTop) > (console.scrollHeight - 20)
	)

	afterUpdate(() => autoscroll && down())

	onMount(down)

	let newCommand = ''
	function submit() {
		if ('' === newCommand)
			return

		send(newCommand, 'console')
		newCommand = ''
	}
</script>

<pre bind:this={console}>
{#each $messages as line}
	<strong title={line.time.toISOString()}>[{line.from}]</strong> {line.line}
{/each}
</pre>

{#if $connected}
<form on:submit|preventDefault={submit}>
	<input
		required
		bind:value={newCommand}
		name=command
		placeholder=COMMAND >
	<button>
		Submit
	</button>
</form>
{/if}

<style>
pre {
	min-height: 4rem;
	width: 100%;
	overflow: auto;
	white-space: pre-wrap;
	background: var(--white);
}

form {
	padding-top: var(--spacing-sm);
	width: 100%;
	display: flex;
	gap: var(--spacing-sm);
}

input {
	width: 100%;
}
</style>
